/**
 * Color tokens based on the design system palette
 * All color values extracted from the color palette specification
 */

export const colors = {
  white: {
    // 0: '#FFFFFF00', // 0% opacity
    // 5: '#FFFFFF0D', // 5% opacity (approximately)
    // 15: '#FFFFFF26', // 15% opacity (approximately)
    // 25: '#FFFFFF40', // 25% opacity (approximately)
    // 35: '#FFFFFF59', // 35% opacity (approximately)
    // 75: '#FFFFFFBF', // 75% opacity (approximately)
    50: 'rgba(255, 255, 255, 0.05)', // 100% opacity
    100: 'rgba(255, 255, 255, 0.15)', // 100% opacity
    200: 'rgba(255, 255, 255, 0.25)',
    300: 'rgba(255, 255, 255, 0.35)',
    400: 'rgba(255, 255, 255, 0.5)',
    500: 'rgba(255, 255, 255, 0.75)',
    600: 'rgba(255, 255, 255, 0.85)',
    700: 'rgba(255, 255, 255, 0.9)',
    800: 'rgba(255, 255, 255, 0.95)',
    900: 'rgba(255, 255, 255, 1)',
  },
  black: {
    // 0: '#171A1D00', // 0% opacity
    // 5: '#171A1D0D', // 5% opacity (approximately)
    // 15: '#171A1D26', // 15% opacity (approximately)
    // 25: '#171A1D40', // 25% opacity (approximately)
    // 35: '#171A1D59', // 35% opacity (approximately)
    // 75: '#171A1DBF', // 75% opacity (approximately)
    // 100: '#171A1D', // 100% opacity
    50: '#171A1D0D',
    100: '#171A1D26',
    200: '#171A1D40',
    300: '#171A1D59',
    400: '#171A1D59',
    500: '#171A1D73',
    600: '#171A1DBF',
    700: '#171A1DBF',
    800: '#171A1D99',
    900: '#171A1D',
  },
  accent: {
    50: '#D3BEF4',
    100: '#D3BEF4',
    200: '#D3BEF4',
    300: '#D3BEF4',
    400: '#D3BEF4',
    450: '#AA82E9',
    500: '#A379E7',
    600: '#8952E0',
    '600_10': '#8952E01A', // 10% opacity
    '600_20': '#8952E033', // 20% opacity
    '600_40': '#8952E066', // 40% opacity
    700: '#8952E0',
    800: '#8952E0',
    900: '#8952E0',
  },
  secondary: {
    50: '#7CB6FC',
    100: '#7CB6FC',
    200: '#7CB6FC',
    300: '#7CB6FC',
    400: '#7CB6FC',
    500: '#478DE3',
    600: '#2C75CD',
    700: '#2C75CD',
    800: '#2C75CD',
    900: '#2C75CD',
  },
  gray: {
    100: '#D3D4D5',
    200: '#ADAFB2',
    300: '#83868A',
    400: '#60646A',
    500: '#3E4249',
    600: '#2F343B',
    700: '#242931',
    800: '#1B1F25',
    900: '#121519',
  },
  red: {
    200: '#f85555',
    400: '#ED6363',
    500: '#E53E3E',
  },
  green: {
    400: '#1DBD88',
  },
  gold: {
    400: '#FFD873',
  },
  alternative: {
    blue: '#478DE3',
    'blue-10': '#478DE31A',
    'blue-20': '#478DE333',
    green: '#0EA371',
    'green-10': '#0EA3711A',
    'green-20': '#0EA37133',
    gold: '#FBC434',
    'gold-10': '#FBC4341A',
    'gold-20': '#FBC43433',
    purple: '#A379E7',
    'purple-10': '#A379E71A',
    'purple-20': '#A379E733',
    red: '#F85555',
    'red-10': '#F855551A',
    'red-20': '#F8555533',
  },
} as const;
